// store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import globalReducer from "./slices/globalSlice";
import activityReducer from "./slices/activitySlice";
import hotelReducer from "./slices/hotelSlice";
import flightReducer from "./slices/flightSlice";
import carReducer from "./slices/carSlice";
import transportReducer from "./slices/transportSlice";
import packageReducer from "./slices/packageSlice";
import restaurantReducer from "./slices/restaurantSlice";
import hostingReducer from "./slices/hostingSlice";
import eventReducer from "./slices/eventSlice";
import stepReducer from "./slices/stepSlice";
import profileReducer from "./profileReducer";


import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const appReducer = combineReducers({
  global: globalReducer,
  activity: activityReducer,
  hotel: hotelReducer,
  flight: flightReducer,
  package: packageReducer,
  car: carReducer,
  transport: transportReducer,
  step: stepReducer,
  profile: profileReducer,
  restaurant: restaurantReducer,
  hosting: hostingReducer,
  events: eventReducer,
});

// Resettable root reducer
const rootReducer = (state, action) => {
  if (action.type === "RESET_STATE") {
    state = undefined; // resets all slices
  }
  if (action.type === "RESET_PRODUCTS_STATE") {
    return {
      ...state,
      activity: undefined,
      hotel: undefined,
      flight: undefined,
      car: undefined,
      transport: undefined,
      package: undefined,
      restaurant: undefined,
      hosting: undefined,
      events: undefined,
    };
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "global",
    "activity",
    "hotel",
    "flight",
    "package",
    "car",
    "transport",
    "restaurant",
    "hosting",
    "events",
    "step",
    "profile",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export const resetState = () => ({ type: "RESET_STATE" });
export const resetProductsState = () => ({ type: "RESET_PRODUCTS_STATE" });
